export default {
  dps: {
    field: 'dps',
    display: 'DPS',
    description: 'Damage per Second',
    sort: 'desc',
    roles: ['dps', 'tank', 'healer'],
  },
  prioritydps: {
    field: 'prioritydps',
    display: 'PDPS',
    description: 'Damage per Second to Priority Target/Boss',
    sort: 'desc',
    roles: ['dps', 'tank', 'healer'],
  },
};
